<template>
    <div class="captail_wrap registrationSteps position-relative fullLoader p-0 w-100">
		<loader v-if="pageLoader"></loader>
        
        <div class="middle_section m-0">
            <div class="top_searchbars">
                <div class="row">
                    <div class="col-12">
					    <div class="cap_logo_steps p-3 d-flex justify-content-between align-items-center">
                            <router-link to="/home"><img src="../../../../../static/website/images/logo.svg" alt="Captail wallet"></router-link>
                            <div class="rightBack d-flex align-items-center">
                            <router-link  class="backToDash mr-2" :to="'/corporate-step1'"><feather type="chevron-left"></feather></router-link>
							<router-link class="backToDash" :to="'/home'"><feather type="home"></feather></router-link>
                            </div>
                        </div>
						
                    </div>
                </div>
            </div>
            <div class="mid_scroll_content d-flex align-items-center justify-content-center">
                <section class="stepsForm-include valigncenter border-0 w-100">
                    <div class="row justify-content-center pb-3">
                        <alert-notification v-if="notification_msg != ''"/>
                        <div class="col-12 col-lg-7 stepBorder box-shadow text-center">
                         <!-- <h3 class="text-center">Personal Information</h3> -->
                         <h3 class="text-center mb-4">Authorization representative details </h3>
                         <p>Please provide your legal full name and the address from the country of your residence. Country of residence is where you primarily live, do banking and receive important emails </p>
                            <form class="mt-4" >
                                <div class="row personalInfo">
									<div class="col-md-12 text-left mb-3">
                                        <h5 class="mb-3">You are applying for a corporate account as the representative of your organization</h5>
                                        <div class="d-flex align-items-center my-2">
                                        <div class="form-group mb-0 mr-3">
                                            <label class="customRadioButton">Yes
                                              <input type="radio" value="1" name="radio" v-model="org_representative">
                                              <span class="checkmark"></span>
                                            </label>
                                        </div>
                                        <div class="form-group mb-0">
                                            <label class="customRadioButton">No
                                              <input type="radio" value="0"  name="radio" v-model="org_representative">
                                              <span class="checkmark"></span>
                                            </label>
                                        </div>
                                        </div>
                                        <div v-if="org_representative == 0">
                                            <span class="text-danger">Only authorised representatives or UBO (Ultimate Beneficiary Owners) of an organization can set up corporate accounts. Others, please use individual account registration to sign up</span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="labeltext">Your Legal Name</label>
                                            <input type="text" class="form-control" name="legal_name" v-model="fname" v-validate="'required'" placeholder=" " :disabled="(org_representative == 0)?true:false">
											<span v-show="submitted && errors.has('legal_name')" class="text-danger">The Name is required</span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group" :class="(dob != '' || dateFocus)? 'active' : ''">
											<label class="labeltext"> Date Of Birth </label>
											<!-- <datepicker class="form-control datepicker" :typeable="true" placeholder=" DD-MMM-YYYY" name="dob" v-model="dob" v-validate="'required'" :disabledDates="disabledDates" :disabled="(org_representative == 0)?true:false"> </datepicker> -->
                                            <datepicker class="form-control datepicker" :typeable="true" @focus="dateFocus = true" @blur="dateFocus = false" @clear="dob = ''" :format="'DD-MM-YYYY'" placeholder=" " name="dob" v-model="dob" v-validate="'required'" :lang="'en'" :disabled="(org_representative == 0)?true:false"> </datepicker>
											<span v-show="submitted && errors.has('dob')" class="text-danger">The Date is required</span>
                                            <span v-if="submitted && !is_18()" class="text-danger">Age should be greater than 18 Years</span>
                                        </div>
                                    </div>
									<div class="col-md-6">
                                        <div class="form-group">
                                            <label class="labeltext">Job Title</label>
                                            <input type="text" class="form-control" name="job_title"  v-model="job_title" v-validate="'required'" placeholder=" " :disabled="(org_representative == 0)?true:false">
											<span v-show="submitted && errors.has('job_title')" class="text-danger">The job title is required</span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="labeltext">Address</label>
                                            <input type="text" class="form-control" name="address"  v-model="address1" v-validate="'required'" placeholder=" " :disabled="(org_representative == 0)?true:false">
											<span v-show="submitted && errors.has('address')" class="text-danger">The Address is required</span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group" :class="(nationality != '')? 'active' : ''">
											<label class="labeltext">Select Nationality </label>
											<v-select :options="Object.values($env_var.countriesList)" :reduce="country => country.code" v-model="nationality" label="name" placeholder=" " name="nationality" v-validate="'required'" :disabled="(org_representative == 0)?true:false" ></v-select>
											<span v-show="submitted && errors.has('nationality')" class="text-danger">The Nationality is required</span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="labeltext">City </label>
                                            <input type="text" class="form-control" name="City" v-model="city" v-validate="'required'" placeholder=" " :disabled="(org_representative == 0)?true:false">
											<span v-show="submitted && errors.has('City')" class="text-danger">The City is required</span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group" :class="(residence_country != '')? 'active' : ''">
											<label class="labeltext">Select Country</label>
											<v-select :options="Object.values($env_var.countriesList)" :reduce="country => country.code" v-model="residence_country" label="name" placeholder=" " name="Country" v-validate="'required'" :disabled="(org_representative == 0)?true:false" ></v-select>
											<span v-show="submitted && errors.has('Country')" class="text-danger">The Country is required</span>
                                        </div>
                                    </div>
                                    
                                    <div class="col-12">
                                        <div class="submitButton text-center my-4">
                                            <input type="button" class="cap_btn blue px-4 large_btn" :class="(pageLoader)?'disabled':''" v-if="org_representative == 1" value="Save & Continue" v-on:click.stop.prevent="submit">
                                            <input type="button" class="cap_btn blue px-4 large_btn disabled"  value="Save & Continue" v-on:click.stop.prevent="" v-else>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
import { registerStepsMixins } from '@/plugins/registerSteps'
import moment from 'moment'
export default {
    name: 'step-four',
    mixins: [registerStepsMixins],
    data() {
        return {
			submitted : false,
			pageLoader : false,
            notification_msg:'',
            notification_type:'',
			fname : '',
			dob : '',
            dateFocus: false,
			address1 : '',
			nationality : '',
			city : '',
			residence_country : '',
			org_representative : '1',
			job_title : '',
            disabledDates: {
                from: new Date(),
            }
		}
    },
	methods: {
        is_18(){
            let dob = new Date(this.dob)
            let get_year = new Date().getFullYear() - 18
            if(!this.dob) return false;
            else if(dob.getFullYear() > get_year) return false;
            else if(dob.getFullYear() < get_year) return true;
            else return false;
        },
		submit(){
            if(this.pageLoader){return;}
			const _that = this
			this.submitted = true;
			this.$validator.validate().then(valid => {
                if(!this.$env_var.countriesList[_that.nationality]){
                    _that.nationality = ''
                    return
                }else if(!this.$env_var.countriesList[_that.residence_country]){
                    _that.residence_country = ''
                    return
                }else if (valid && _that.is_18()) {
					let input_json={
						'globalParams' :{
							"fname" : _that.fname, 
							"dob" : moment(_that.dob).format(), 
							"address1" : _that.address1, 
							"nationality" : _that.nationality, 
							"city" : _that.city, 
							"residence_country" : _that.residence_country,
							"org_representative" : _that.org_representative,  
							"job_title" : _that.job_title,
							'step' : '2'
						},
						'localParams' :{ "parameter" : _that }
					}
					_that._runCorStep5(input_json)
				}
			})
		}
	},
	created(){
		this._runGetStepInfo({'globalParams' :{"step" : '2'},'localParams' :{ "parameter" : this}})
	}
}
</script>



// WEBPACK FOOTER //
// src/components/website/registerSteps/corporate/corporate_step2.vue